module.exports = __webpack_public_path__ + "static/media/csi.d8d4d303.png";